import { render, staticRenderFns } from "./PayBusinessInfo.vue?vue&type=template&id=740c685e"
import script from "./PayBusinessInfo.vue?vue&type=script&lang=js"
export * from "./PayBusinessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports